module.exports = __webpack_public_path__ + "img/tree-01-a-leaves.56a4d3d4.png";